import { resolve } from 'styled-jsx/css';
import { colors, screen } from 'components/styles/variables';
import { FunctionComponent, HTMLAttributes } from 'react';

export interface LinkProps {
  href: string;
  as?: string;
  className: string;
  onClick: () => void;
  children: (string | JSX.Element)[];
  anchorProps?: Partial<HTMLAttributes<HTMLAnchorElement>> & Record<string, string>;
}

/* istanbul ignore next */
export const css = resolve`
  a {
    color: white;
    font-size: 16px;
    line-height: 2;
    text-rendering: optimizeLegibility;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.004);
  }

  @media (min-width: ${screen.mdMin}) {
    a {
      font-size: 18px;
    }
  }

  a:hover {
    text-decoration: none;
    color: ${colors.G2};
  }

`;

const Link: FunctionComponent<LinkProps> = ({
  href,
  children,
  className,
  onClick,
  anchorProps = {},
}: LinkProps) => (
  <>
    <a
      href={href}
      {...anchorProps}
      target="_top"
      className={`${className || ''} ${css.className}`}
      onClick={onClick}
    >
      {children}
    </a>
    {css.styles}
  </>
);

export default Link;
